<div mat-subheader *ngIf="item.navCap" class="nav-caption">
  {{ item.navCap }}
</div>

<ng-container *ngIf="!item.navCap">
  <!-- Item com children: cabeçalho colapsável -->
  <a
    mat-list-item
    (click)="onItemSelected(item)"
    class="menu-list-item"
    *ngIf="item.children && item.children.length"
  >
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName }}</span>
    <i-tabler
      class="hide-menu"
      [name]="expanded ? 'chevron-up' : 'chevron-down'"
      style="width:16px;height:16px;margin-left:auto;"
    ></i-tabler>
  </a>

  <!-- Sub-itens -->
  <div *ngIf="expanded && item.children && item.children.length" class="sub-menu" style="padding-left: 16px;">
    <app-nav-item
      *ngFor="let child of item.children"
      [item]="child"
      [depth]="depth + 1"
    ></app-nav-item>
  </div>

  <!-- Item folha (sem children) -->
  <a
    mat-list-item
    (click)="onItemSelected(item)"
    [ngClass]="{
      'mat-toolbar mat-primary activeMenu': item.route
        ? router.isActive(item.route, true)
        : false,
    }"
    class="menu-list-item"
    *ngIf="!item.children || !item.children.length"
  >
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName }}</span>
  </a>
</ng-container>
